import React from 'react'
import NextImage from 'next/image'

import {
  Dialog,
  DialogContent,
  DialogCloseButton,
  DialogHeader,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type TDialogPraktikKinerjaInfoProps = {
  isOpen: boolean
  onClose: () => void
}
export const DialogPraktikKinerjaInfo: React.FC<
  TDialogPraktikKinerjaInfoProps
> = ({ isOpen, onClose }) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      autoFocus={false}
      returnFocus={false}
      size="lg"
    >
      <DialogOverlay />
      <DialogContent>
        <DialogHeader title="Tentang Praktik Kinerja" />
        <div className="grid grid-cols-12 p-6 gap-x-16">
          <div className="col-span-6 space-y-4">
            <div className="space-y-1">
              <Text variant="heading-sm">Sebuah Potret Kinerja</Text>
              <Text>
                Bayangkan Praktik Kinerja sebagai sebuah potret atau capaian
                yang dapat Pengawas Sekolah tunjukkan di satuan pendidikan
                dampingannya.
              </Text>
            </div>

            <div>
              <NextImage
                src="/images/kinerja/praktik-kinerja-info.jpg"
                width="450px"
                height="250px"
              />
            </div>
          </div>
          <div className="col-span-6 space-y-8">
            <div className="space-y-1">
              <Text variant="heading-sm">Tahap Perencanaan</Text>
              <Text>
                <ol className="pl-6 list-decimal">
                  <li>
                    Memilih 1 praktik untuk menjadi fokus peningkatan kinerja.
                  </li>
                  <li>
                    Memilih 3 satuan pendidikan untuk menjadi fokus dalam
                    melakukan praktik.
                  </li>
                </ol>
              </Text>
            </div>

            <div className="space-y-1">
              <Text variant="heading-sm">Tahap Pelaksanaan</Text>
              <Text>
                <ol className="pl-6 list-decimal">
                  <li>Diskusi Persiapan</li>
                  <li>Pendampingan Satuan Pendidikan</li>
                  <li>Diskusi Tindak Lanjut</li>
                  <li>Upaya Tindak Lanjut</li>
                  <li>Refleksi Tindak Lanjut</li>
                </ol>
              </Text>
            </div>

            <div className="space-y-1">
              <Text variant="heading-sm">Tahap Penetapan Predikat Kinerja</Text>
              <Text>
                Tim Kinerja akan memberikan rekomendasi rating Praktik Kinerja
                berdasarkan pelaksanaan yang dilakukan. Pejabat Penilai Kinerja
                lalu akan melakukan finalisasi saat Penetapan Predikat Kinerja.
              </Text>
            </div>
          </div>
        </div>
        <DialogCloseButton />
      </DialogContent>
    </Dialog>
  )
}
